import { useState, useEffect } from "react";
import { Cookie } from "lucide-react";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("mag_cookie_consent");
    if (!consent) {
      const t = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (value) => {
    localStorage.setItem("mag_cookie_consent", value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[80] p-3 pb-24 lg:p-4">
      <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-2xl border border-slate-200 p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-blue-50 text-blue-600 shrink-0">
            <Cookie className="w-5 h-5" />
          </div>
          <p className="text-[14px] leading-relaxed text-slate-600">
            Wir verwenden Cookies, um Ihnen die bestmögliche Nutzung unserer Website
            zu ermöglichen. Details finden Sie in unserer Datenschutzerklärung.
          </p>
        </div>
        <div className="flex gap-3 shrink-0">
          <button
            onClick={() => decide("essential")}
            className="px-4 py-2.5 rounded-lg border border-slate-300 text-slate-700 text-[14px] font-semibold hover:bg-slate-50 transition-colors"
          >
            Nur notwendige
          </button>
          <button
            onClick={() => decide("all")}
            className="px-4 py-2.5 rounded-lg bg-blue-600 text-white text-[14px] font-semibold hover:bg-blue-700 transition-colors"
          >
            Akzeptieren
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
